// material-ui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

// third-party
import { FormattedMessage } from "react-intl";

// project imports
import { useSelector, RootState, dispatch } from "store";
import { login } from "store/slices/auth";
import Button from "ui-component/extended/Button";
import useLog from "hooks/useLog";

// assets
import LOGIN_MODAL_BG from "assets/images/loginModal/bg.png";
import LOGIN_MODAL_TITLE_BG from "assets/images/loginModal/title-bg.png";

// styles

// ==============================|| LOADER ||============================== //

const LoginModal = (): JSX.Element => {
  const log = useLog();
  const auth = useSelector((state: RootState) => state.auth);

  return (
    <Modal open={!auth.isLoggedIn} disableEnforceFocus disableAutoFocus>
      <Grid
        container
        direction="column"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "300px",
          height: { xs: "40%", sm: "40%" },
          minHeight: "250px",
          p: "1px",
          background: `no-repeat center/100% 100% url(${LOGIN_MODAL_BG}),#554C42`
        }}
      >
        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: { xs: 52 }, background: `no-repeat center/100% 100% url(${LOGIN_MODAL_TITLE_BG}),#554C42` }}
        >
          <Typography variant="subtitle1">
            <FormattedMessage id="TIPS" />
          </Typography>
        </Grid>

        <Grid item container xs direction="column" alignItems="center" position="relative">
          <Typography variant="body1" sx={{ width: "70%", mt: { xs: "18px" }, textAlign: "center" }}>
            <FormattedMessage id="LOGIN_DESC" />
          </Typography>
          <Grid container sx={{ width: "80%" }} direction="row" justifyContent="center" position="absolute" bottom={{ xs: 20, sm: 40 }}>
            <Button
              scene="LOGIN"
              sx={{ width: "122px", height: "37px", color: "#2E1804", fontSize: "0.875rem" }}
              onClick={() => {
                dispatch(login());

                // log("simulationtools_clicklogin", {});
              }}
            >
              <Typography variant="body2" sx={{ color: "#2E1804", fontSize: "0.875rem" }}>
                <FormattedMessage id="LOGIN" />
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default LoginModal;
